import React, { useEffect, useRef } from 'react';
import { useNova } from '../NovaContext';
import { NOVA_IDS } from '../constants';
import ChatPage from '../pages/ChatPage';
import InsightsPage from '../pages/InsightsPage';
import Composer from './Composer';
import PanelHeader from './PanelHeader';
import TabBar from './TabBar';

const FOCUSABLE = 'button, textarea, input, select, a[href], [tabindex]';

export default function Panel() {
    const { state, actions, refs } = useNova();
    const panelRef = useRef(null);

    useEffect(() => {
        if (!state.open) return undefined;
        const onPointerDown = (event) => {
            const inside = panelRef.current?.contains(event.target) || refs.launcherRef.current?.contains(event.target);
            if (!inside) actions.dismiss();
        };
        document.addEventListener('mousedown', onPointerDown);
        return () => document.removeEventListener('mousedown', onPointerDown);
    }, [state.open, actions, refs.launcherRef]);

    const onKeyDown = (event) => {
        if (event.key === 'Escape') {
            event.stopPropagation();
            actions.close();
            return;
        }
        if (event.key !== 'Tab') return;
        const nodes = [...panelRef.current.querySelectorAll(FOCUSABLE)]
            .filter((node) => !node.disabled && node.tabIndex >= 0 && !node.closest('[hidden]'));
        if (!nodes.length) return;
        const first = nodes[0];
        const last = nodes[nodes.length - 1];
        if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
        }
    };

    return (
        <section
            ref={panelRef}
            id={NOVA_IDS.panel}
            role="dialog"
            aria-label="Foresee AI assistant"
            className="nova_panel"
            hidden={!state.open}
            onKeyDown={onKeyDown}
        >
            <PanelHeader />
            <TabBar />
            <ChatPage />
            <InsightsPage />
            <Composer />
        </section>
    );
}
